import React, { FunctionComponent } from 'react';
import styles from './Message.module.scss';
import { Block, Link, ResponsiveImage, Typography } from 'components/elements';
import { WPAcfMessage } from 'types/acf/messages';
import cx from 'clsx';
import BlockContent from '../BlockContent/BlockContent';
import DOMPurify from 'dompurify';
import { FormattedText } from 'components/presentional';

interface OwnProps {
  data: WPAcfMessage | null;
}

type MessageProps = JSX.IntrinsicElements['div'] & OwnProps;

const Message: FunctionComponent<MessageProps> = props => {
  const { data, className, ...rest } = props;

  if (!data) {
    return null;
  }

  const { title, buttonLabel, buttonLink, image, description } = data;

  const messageClassNames = cx({
    [styles.container]: true,
    ...(className && { [className]: true }),
  });

  return (
    <Block id="message" data-module="message">
      <BlockContent>
        <div className={messageClassNames} {...rest}>
          {image && (
            <div className={styles.image}>
              <ResponsiveImage
                className={styles.icon}
                desktopImage={{ config: image, imgProps: { componentHeight: true } }}
                mobileImage={{ config: image, imgProps: { componentHeight: true } }}
              />
            </div>
          )}
          {title && (
            <Typography className={styles.title} as="h2" mobile="neue_semibold_20" tablet="neue_semibold_20" desktop="neue_semibold_24">
              {title}
            </Typography>
          )}
          {description && <FormattedText className={styles.description} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }} />}
          {buttonLabel && buttonLink && buttonLabel.trim() && (
            <Link className={styles.link} href={buttonLink}>
              {buttonLabel}
            </Link>
          )}
        </div>
      </BlockContent>
    </Block>
  );
};

export default Message;
